import {Component, Input, OnInit} from '@angular/core';
import {Subject} from '@node_modules/rxjs/internal/Subject';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-calendar',
  templateUrl: './modal-calendar.component.html',
  styleUrls: ['./modal-calendar.component.scss']
})
export class ModalCalendarComponent implements OnInit {

  @Input() ref;
  @Input() initDate: {day: number, month: number, year: number};

  monthsNumber: Subject<any> = new BehaviorSubject(null);
  selectedDay: Subject<any> = new BehaviorSubject(null);
  selectedDate: number;
  moveMonthsCarousel: Subject<string> = new BehaviorSubject(null);
  currentYear = new Date().getFullYear();
  currentMonth = moment().month() + 1;
  selectedDayString;
  disablePast = false;
  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  constructor() { }

  ngOnInit() {
    if (this.initDate) {
      this.currentYear = this.initDate.year;
      this.currentMonth = this.initDate.month;
      this.selectedDate = this.initDate.day;
    }
  }

  onMonthToRight() {
    this.currentMonth -= 1;
    if (this.currentMonth < 1) {
      this.currentYear--;
      this.currentMonth = 12;
    }
    this.monthsNumber.next({month: this.currentMonth, year: this.currentYear});
    this.moveMonthsCarousel.next('right');
  }

  onMonthToLeft() {
    this.currentMonth += 1;
    // console.log(this.currentMonth, 'left');
    if (this.currentMonth > 12) {
      this.currentYear++;
      this.currentMonth = 1;
    }
    this.monthsNumber.next({month: this.currentMonth, year: this.currentYear});
    this.moveMonthsCarousel.next('left');
  }
  onSelectedDay(event) {
    event['year'] = this.currentYear;
    this.selectedDayString = moment().date(event.day).month(event.month - 1).year(this.currentYear).format('ll');
    this.selectedDay.next(event);
  }
  close() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
